import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { getImageGroup } from 'planoplan-ui-kit/core/get_image';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { LANG_CAPTION } from '@constants';

export const CurrentLangButton = ({ onClick, lang }) => {
  return (
    <View onClick={onClick}>
      <span>{LANG_CAPTION[lang.lang]}</span>
    </View>
  );
};

const View = styled.button`
  ${Mixins.resetButton()};
  ${Mixins.transition('border-color, color')};
  margin-right: 32px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid ${Colors.night};
  color: ${Colors.night};
  font-size: 18px;
  line-height: 18px;

  span {
    margin-top: -1px;
  }

  &:hover {
    color: ${Colors.electric_blue};
    border-color: ${Colors.electric_blue};
  }
`;
